import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=27a2f6a4&scoped=true&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=27a2f6a4&prod&scoped=true&lang=css&"
import style1 from "./AddCompany.vue?vue&type=style&index=1&id=27a2f6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2f6a4",
  null
  
)

export default component.exports